import React, { Component } from "react";
import ProductHeader from "../../ProductDetails/ProductHeader";
import { connect } from "react-redux";
import Hmm from "./hmm.png";
import Details from "./Details";
import Address from "./Address";
import Hours from "./Hours";
import { Redirect } from "react-router";
import { CircularProgress } from "@material-ui/core";
import { loadBranchDetails } from "../../../store/actions";

class BranchDetail extends Component {
  componentDidMount = async () => {
    window.scrollTo(0, 0);
    const branchID = this.props.match.params.branchID;
    const branch = this.props.branches.find((branch) => branch.id == branchID);

    if (branch?.loaded_details === false) {
      await this.props.loadBranchDetails(branch?.id);
    }
  };

  render() {
    const language = this.props.language;
    const settings = this.props.settings;
    const branchID = this.props.match.params.branchID;
    const branch = this.props.branches.find((branch) => branch.id == branchID);

    if (!branch || branch.hide_branch) {
      return <Redirect to="/contact" />;
    }

    // return (
    //   <div style={{ minHeight: "calc(100vh - 55px)" }}>
    //     <ProductHeader onBack={() => this.props.history.replace("/")} />
    //     <div style={{ marginTop: 100 }}>
    //       <img src={Hmm} style={{ width: 180, height: 200 }} />
    //       <p className="mt-3">
    //         {language == "english"
    //           ? "Sorry.. Can't find the page you're looking for"
    //           : "عذرا.. لم نتمكن من ايجاد هذه الصفحة"}
    //       </p>
    //     </div>
    //   </div>
    // );

    return (
      <div
        style={{
          backgroundColor: "white",
          minHeight: "100vh",
          backgroundColor: "#F5F5F5",
        }}
      >
        <ProductHeader
          onBack={() => {
            this.props.history.replace(
              this.props.history.location.state?.fromContactPage
                ? "/contact"
                : "/select/branch",
              { type: 1 }
            );
            this.props.history.goBack();
          }}
        />

        <div style={{ marginTop: 80 }}>
          {!branch.loaded_details ? (
            <CircularProgress
              color="primary"
              style={{ marginTop: 15, marginBottom: 15 }}
            />
          ) : (
            <>
              <Details branch={branch} />
              <Address branch={branch} />
              <Hours branch={branch} />
            </>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    branches: state.store.store.branches,
    language: state.store.language,
    settings: state.store.store.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadBranchDetails: (branchId) => dispatch(loadBranchDetails(branchId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BranchDetail);
